import React from 'react';
import '../Footer/Styles.css';

const Footer = () => {
  return (
    <>
        <div className='footerContainer'>
            <p className='footerName'>© 2026 Mindful Breaks Yoga. Alle rechten voorbehouden.</p>
        </div>
    </>
  )
}

export default Footer
